export default {
  // 搜索相關
  searchPlaceholder: "搜索地址/哈希/調證用戶ID",
  dataDetails: "數據詳情",

  // 頁面標題
  transactionDetails: "交易詳情",

  // 按鈕
  joinCanvas: "加入畫布",
  browserView: "瀏覽器查看",
  addRemark: "點擊添加備註",
  reset: "重置",
  query: "查詢",
  downloadDetails: "下載數據明細",

  // 交易信息
  sender: "發送方",
  receiver: "接收方",
  interactor: "交互方",
  smartContract: "智能合約",
  transactionTime: "交易時間",
  transactionAmount: "交易數量",
  transactionFee: "交易手續費",

  // 表格相關
  tokenTransfer: "代幣轉賬",
  senderAddress: "發送方地址",
  receiverAddress: "接收方地址",
  pleaseSelect: "請選擇",
  currency: "幣種",
  amount: "數量",

  // 加載和狀態
  loading: "拼命加載中",
  noData: "暫無數據",

  // 消息提示
  addressNotFound: "沒有查出該地址",

  // 下載文件名
  dataDetailsFileName: "數據明細",

  // 數據統計
  totalDataPrefix: "共計",
  totalDataSuffix: "條數據",
  downloadLimit: "注：最多可下載1萬條數據",

  // 備註
  note: "備註:",
};
